import { createMuiTheme } from '@material-ui/core'
import { TypographyOptions } from '@material-ui/core/styles/createTypography'

const defaultTheme = createMuiTheme()

export const fonts = {
  sf: 'SF Pro Display',
  rubik: '"Rubik", sans-serif'
}

const typography: TypographyOptions = {
  fontFamily: fonts.sf,
  h1: {
    fontSize: 32,
    fontWeight: 500,
    lineHeight: 1.25,

    [defaultTheme.breakpoints.down('sm')]: {
      fontSize: 26
    }
  },
  h2: {
    fontSize: 32
  },
  h3: {
    fontSize: 30,

    [defaultTheme.breakpoints.down('xs')]: {
      fontSize: 24
    }
  },
  h4: {
    fontSize: 24
  },
  h5: {
    fontSize: 20
  },
  subtitle1: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 1.22
  },
  body1: {
    fontSize: 16,
    lineHeight: 1.25
  },
  body2: {
    fontSize: 14
  }
}

export default typography
